module.exports = __webpack_public_path__ + "img/regular.45b1709f.png";